import React from 'react';

const SUBSCRIBE_URL = 'https://noohrawrites.substack.com/?utm_campaign=email-home&r=4xjwrw';

export default function NewsletterForm({ btnText, btnArrowUrl }) {
  return (
    <a href={SUBSCRIBE_URL} target="_blank" rel="noreferrer" className="cs_btn cs_style_1">
      <span>{btnText}</span>
      <i>
        <img src={btnArrowUrl} alt="" />
        <img src={btnArrowUrl} alt="" />
      </i>
    </a>
  );
}
